import React, { useState, useEffect } from 'react';
import { fromJS } from 'immutable';
import { connect } from 'react-redux';
import { Form, Field, reduxForm , destroy} from 'redux-form';
import { ToastContainer, toast } from 'react-toastify';
import UserSideMenu from '../../menu/UserSideMenu';
import Header from '../common/HeaderAfterLogin';

import 'react-toastify/dist/ReactToastify.css';
import { InputContact, DropDownContact,DropDownContactDistrict } from '../common/input';
import { getState } from '../../action/user_action';
import Footer from '../common/Footer';
import { scrollHandler, goToByScroll } from '../../util/animation';
// import Header from '../common/Header';
import { axiosInstnace as Axios } from '../../util/util';
import { endPoints } from '../../config';
import { history } from '../../history/history';
import {phoneNumber, email, string, maxLengthCheck} from '../../util/validate';
import AOS from 'aos';

const Contact = props => {

    //Define the initial state.
  const [stateList, handleCityState] = useState([]);
  const [message, handleMessage] = useState('');
  const [districtList, handleDistrict] = useState([]);
  const [cityList, handleCity] = useState([]);

  //Initialize the scroll function
  useEffect(() => {
    window.addEventListener('scroll', scrollHandler);
    props.getState();
    AOS.init({
      duration: 600,
    });
    return () => {
      window.removeEventListener('scroll', scrollHandler)
    }
  }, []);

  const handleStateCity = async(state) => {
    const response = await Axios.get(`${endPoints.getCities}?state=${state}`);
    console.log(response.data.data.data);
    let cityList = response.data.data.data;
    handleCityItems(cityList);
  }

  const handleCityItems = (cityList) => {
    let cityListItems = cityList.map(d => ({
      name:d.city,
      value:d.city
    }))
    console.log(cityListItems);
    handleCity(fromJS(cityListItems));

  }

    //Fetch the state list from backend
    useEffect(()=>{
      if(props.stateList && props.stateList.size>0){
        console.log(props.stateList.size);
        console.log(props.stateList[props.stateList.size]);
        props.stateList[props.stateList.size] = 'Outside India';
        console.log(props.stateList);
       let stateList = props.stateList.toJS().map(s =>({
         name:s,
         value:s
       }))
        handleCityState(fromJS(stateList))
      }
        },[props.stateList])

  /**
   * Submit the contact form that
   * containing the info object about the contact.
   */
  const handleSubmit = async values => {
    var mobileError = values.mobile ? phoneNumber(values.mobile) : undefined;
    var emailError = values.email ? email(values.email) : undefined;
    //  var nameError = values.name ? string(values.name): undefined
    //  var cityError = values.city ? string(values.city):undefined
    var nameLengthError = values.name ? maxLengthCheck(30, values.name) : undefined
    var cityLengthError = values.city ? maxLengthCheck(30, values.city) : undefined
    var emailLengthError = values.email ? maxLengthCheck(30, values.city) : undefined
    var companyLengthError = values.company ? maxLengthCheck(60, values.city) : undefined

    if (nameLengthError && !toast.isActive("1")) {
      toast.error("name " + nameLengthError, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1"
      });
      return;
    } else if (companyLengthError && !toast.isActive("1")) {
      toast.error("company " + nameLengthError, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1"
      });
      return;

    } else if (emailLengthError && !emailError && !toast.isActive("1")) {
      toast.error("email " + emailLengthError, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1"
      });
      return;

    } else if (cityLengthError && !toast.isActive("1")) {
      toast.error("city " + cityLengthError, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1"
      });
      return;

    } else if (mobileError && !toast.isActive("1")) {
      toast.error(mobileError, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1"
      });
      return;

    } else if (emailError && !toast.isActive("1")) {
      toast.error(emailError, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1"
      });
      return;

    } else if (Object.keys(values).length != 6 && !toast.isActive("1")) {
      toast.error('All Fields are mandatory', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1"
      });
      return;

    }
    if (Object.keys(values).length != 6 || mobileError || emailError || nameLengthError || cityLengthError || emailLengthError || companyLengthError) {
      return;
    }
    let params = {
      ...values,
      message,
      status: 'Open'
    }
    try {
      const data = await Axios.post(endPoints.contact, params);
      const result = data.data.data.data;
      if (result) {
        props.destroyForm('contact');
        handleMessage('')
        toast.error('Thank You for connecting us,We will respond soon', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: false,
          hideProgressBar: true,
          toastId: "1"
        });
        setTimeout(() => {
          history.push('');
        }, 2000)

      }
    } catch (error) {
      console.log(error);
    }
  }

  //Getting the contat message
  const getMessage = e => {
    let message = e.target.value;
    if (message.length < 175) {
      handleMessage(message)
    } else {
      return
    }

  }

  const handleStateDistrict = async(state) => {
    const response = await Axios.get(`${endPoints.getDistrictList}?state=${state}`);
    console.log(response.data.data.data);
    let districtList = response.data.data.data;
    handleStateCity(districtList);
  }

  const handleDistrictItems = (districtList) => {
    let districtListItems = districtList.map(d => ({
      name:d.district,
      value:d.district
    }))
    console.log(districtListItems);
    handleDistrict(fromJS(districtListItems));

  }

  const handleArrowChange =(e) =>{
    console.log(e.target.value);
    handleStateCity(e.target.value);
  }



//   render() {
//     let { kycDetails } = this.state;
    return (
      <div className="main_wrapper">
        <UserSideMenu {...props} />
        <div className="dashboard_right_wrapper create_camp_container">
          <div className="right_wrapper_inner">
            <Header />
            <div className="dash_content_wrapper">

              <div className="content_wrapper_inner detail_content">
                <div className="create_kyc_wrapper">
                  <h2 className="detail_kyc_header">CONTACT DETAILS</h2>
                  <div className="kycdetails_wrapper">
                    <h2 className="kycheader"></h2>
                    <div className="form_wrapper">
            <p className="form_header">Fill the form below. We will get in touch with you as soon as we can!</p>
            <div className="contact_form">
              {/* <form className="contact_form"> */}
              <Form className="contact_form" onSubmit={props.handleSubmit(handleSubmit)}>
                <div className="form_left_wrapper">
                  <div className="form_left">
                    <div className="contact_field">
                      <div className="contact_label"><label>Name</label></div>
                      <div className="contact_input">
                        {/* <input type="text" placeholder="Enter your name"/> */}
                        <Field
                          type="text"
                          name="name"
                          placeholder="Enter your name"
                          component={InputContact}

                        />
                      </div>
                    </div>
                    <div className="contact_field">
                      <div className="contact_label"><label>Email ID</label></div>
                      <div className="contact_input">
                        {/* <input type="email" placeholder="Enter valid email id"/> */}
                        <Field
                          type="text"
                          name="email"
                          placeholder="Enter valid email id"
                          component={InputContact}
                        />
                      </div>
                    </div>
                    <div className="contact_field">
                      <div className="contact_label"><label>Mobile</label></div>
                      <div className="contact_input">
                        {/* <input type="text" placeholder="Enter your mobile number" /> */}
                        <Field
                          type="text"
                          name="mobile"
                          placeholder="Enter your mobile number"
                          component={InputContact}

                        />
                      </div>
                    </div>
                    <div className="contact_field">
                      <div className="contact_label"><label>Company Name</label></div>
                      <div className="contact_input">
                        {/* <input type="text" placeholder="Enter the company name" /> */}
                        <Field
                          type="text"
                          name="company"
                          placeholder="Enter the company name"
                          component={InputContact}
                        />
                      </div>
                    </div>
                    <div className="contact_field">
                      <div className="contact_label"><label>State</label></div>
                      <div className="contact_input">
                        {/* <select>
                          <option>Select state</option>
                          <option>1</option>
                          <option>2</option>
                        </select> */}
                        <Field
                          type="text"
                          name="state"
                          label="State"
                          component={DropDownContact}
                          options={stateList}
                          onChange={handleArrowChange}
                        />

                      </div>
                    </div>
                     {/*<div className="contact_field">
                          <div className="contact_label"><label>District</label></div>
                          <div className="contact_input">
                              <Field
                                  type="text"
                                  name="district"
                                  label="District"
                                  component={DropDownContactDistrict}
                                  options={districtList}
                              />
                          </div>
                      </div>*/}


                      <div className="contact_field">
                      <div className="contact_label"><label>City</label></div>
                      <div className="contact_input">

                        <Field
                          type="text"
                          name="city"
                          label="City"
                          component={DropDownContactDistrict}
                          options={cityList}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="contact_submit">
                    <button >SUBMIT</button>
                  </div>
                </div>
                <div className="form_right">
                  <div className="contact_label"><label>Your Message</label></div>
                  <textarea placeholder="Anything you'd like to share..." value={message} onChange={getMessage.bind(this)}></textarea>
                </div>
              </Form>
            </div>
          </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
//   };
}


const mapStateToProps = state => ({ stateList: state.user.get('stateList') })

export default connect(mapStateToProps, {
  getState,
  destroyForm: destroy
})(
  reduxForm({
    form: 'contact'
  })(Contact));



// export default connect(mapStateToProps, mapDispatchToProps)(KycDetailComp);



// WEBPACK FOOTER //
// ./web/components/contact/contactDashboard.js